import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";

const TRACKED = ["/", "/chat", "/aszf", "/adatvedelem"];

// Cookieless page view counter: no identifiers are stored in the browser.
export const usePageTracking = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!TRACKED.includes(pathname)) return;
    const first = !sessionStorage.getItem("esc_ref_sent");
    sessionStorage.setItem("esc_ref_sent", "1");
    axios.post(`${API}/track`, { path: pathname, referrer: first ? document.referrer : "" }).catch(() => {});
  }, [pathname]);
};
